import React, { useEffect } from 'react';

const Modal = ({ 
  isOpen, 
  onClose, 
  children, 
  className = '',
  maxWidth = 'max-w-modal-sm md:max-w-modal-md lg:max-w-modal-lg',
  hideCloseButton = false,
  backdropOpacity = 1,
  backdropStyle = {},
  ...props 
}) => {
  // Add/remove modal-open class to body when modal opens/closes
  useEffect(() => {
    if (isOpen) {
      document.body.classList.add('modal-open');
    } else {
      document.body.classList.remove('modal-open');
    }

    // Cleanup function to remove class when component unmounts
    return () => {
      document.body.classList.remove('modal-open');
    };
  }, [isOpen]);

  if (!isOpen) return null;

  const handleBackdropClick = (e) => {
    // Only close if clicking directly on the backdrop, not on the modal content
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div 
      className="fixed inset-0 flex items-center justify-center z-50 p-3 md:p-6 mobile-safe"
      style={{ 
        backgroundColor: Object.keys(backdropStyle).length > 0 
          ? 'transparent'
          : backdropOpacity === 0 
          ? 'transparent'
          : backdropOpacity < 1 
          ? `rgba(249, 248, 246, ${backdropOpacity})` 
          : '#F9F8F6',
        ...backdropStyle
      }}
      onClick={handleBackdropClick}
    >
      <div 
        className={`${className.includes('!bg-transparent') ? '' : 'bg-neutral-0'} hairline ${maxWidth} w-full max-h-[95vh] md:max-h-[90vh] overflow-auto ${className}`}
        style={{ 
          position: 'relative',
          zIndex: 10,
          ...(props.style || {})
        }}
        onClick={(e) => e.stopPropagation()}
        {...props}
      >
        {!hideCloseButton && (
          <div className={`sticky top-0 ${className.includes('!bg-transparent') ? 'bg-transparent border-none' : 'bg-neutral-0 border-b border-neutral-200'} p-3 md:p-4 flex justify-end z-10`}>
            <button 
              onClick={onClose}
              className="text-neutral-900 hover:opacity-60 transition-opacity duration-120 font-mono text-lg border-none bg-transparent p-0 m-0 modal-close touch-target"
              style={{ border: 'none', background: 'transparent', padding: 0, margin: 0 }}
            >
              ✕
            </button>
          </div>
        )}
        <div className={className.includes('p-0') ? '' : 'p-3 md:p-6'}>
          {children}
        </div>
      </div>
    </div>
  );
};

export default Modal; 